export const LOGGED_IN = 'loggedIn'
export const VEDA_DETAILS_UPDATED = 'vedaDetailsUpdated'
